import { CodeNameType } from 'components/common/types/AssetList.types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler, SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getNetworks } from 'modules/api/inventory';
import { formatFilterOptionsName } from 'utils/formatters';
import { FilterNetworkProps } from './FilterNetwork.types';

const FilterNetwork: React.FC<FilterNetworkProps> = ({ changeFilters, network }) => {
  const fetchFilterOptions = async (query: string): Promise<CodeNameType[]> => {
    if (query.length >= 3) {
      try {
        return await getNetworks(cancelFunctions, query);
      } catch (error) {
        return [];
      }
    }
    return [];
  };

  const loadFilterOptions: AsyncSelectLoadDataHandler<CodeNameType> = async (_, query) => {
    return formatFilterOptionsName(await fetchFilterOptions(query));
  };

  const onSelect: SelectHandler<CodeNameType> = (_, value: CodeNameType) => {
    changeFilters({ network: value });
  };

  return (
    <AsyncSelect
      dataTestId="network-input"
      name="network"
      loadData={loadFilterOptions}
      onSelect={onSelect}
      placeholder="Network"
      selectedValue={network}
    />
  );
};

export default FilterNetwork;
